import React from 'react';
import { FileX, DollarSign } from 'lucide-react';
const problems = [{
  number: 1,
  icon: DollarSign,
  title: 'Los gastos "extra" aparecen sin explicación.'
}, {
  number: 2,
  icon: FileX,
  title: 'Documentación Incompleta'
}];
const timelineItems = ['Las decisiones se toman con afán y sin información.', 'No se logra el resultado esperado', 'La obra queda incompleta.'];
export function ProblemSection() {
  return <section className="bg-white py-12 md:py-20" style={{
    contentVisibility: 'auto'
  }} data-id="element-193">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6" data-id="element-194">
        <div className="text-center mb-8 md:mb-16" data-id="element-195">
          <h2 className="text-[26px] md:text-[40px] font-bold text-[#1A1A1A] mb-4" style={{
          lineHeight: '1.2',
          letterSpacing: '-0.02em'
        }} data-id="element-196">
            Menos excusas, más cumplimiento.
          </h2>
          <p className="text-[15px] md:text-[17px] text-[#1A1A1A]/60 font-normal max-w-2xl mx-auto" style={{
          lineHeight: '1.6'
        }} data-id="element-197">
            La mayoría de obras fallan por dos razones:
          </p>
        </div>

        {/* Problems Grid */}
        <div className="grid md:grid-cols-2 gap-6 md:gap-8 mb-12 md:mb-16" data-id="element-198">
          {problems.map(problem => {
          const Icon = problem.icon;
          return <div key={problem.number} className="bg-white border-2 border-[#1A1A1A]/10 rounded-3xl p-6 md:p-8 hover:border-[#E8621A]/30 transition-all hover:shadow-xl" data-id="element-199">
                <div className="flex items-center gap-4" data-id="element-200">
                  <div className="flex-shrink-0 w-12 h-12 bg-[#E8621A]/10 rounded-2xl flex items-center justify-center" data-id="element-201">
                    <span className="text-[#E8621A] font-black text-xl" data-id="element-202">
                      {problem.number}
                    </span>
                  </div>
                  <div className="flex-1" data-id="element-203">
                    <div className="flex items-center gap-3" data-id="element-204">
                      <Icon className="w-10 h-10 md:w-12 md:h-12 text-[#E8621A]" data-id="element-205" />
                      <h3 className="text-[20px] md:text-[28px] font-semibold text-[#1A1A1A]" style={{
                    lineHeight: '1.3'
                  }} data-id="element-206">
                        {problem.title}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>;
        })}
        </div>

        {/* Timeline Section */}
        <div className="max-w-2xl mx-auto" data-id="element-207">
          <h3 className="text-[20px] md:text-[28px] font-semibold text-[#1A1A1A] mb-6 md:mb-8 text-center" style={{
          lineHeight: '1.3'
        }} data-id="element-208">
            Como resultado:
          </h3>

          <div className="relative" data-id="element-209">
            {/* Vertical line */}
            <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-[#E8621A]/20" data-id="element-210" />

            <div className="space-y-6" data-id="element-211">
              {timelineItems.map((item, index) => <div key={index} className="relative flex items-start gap-4 pl-12" data-id="element-212">
                  {/* Timeline dot - minimum 44px tap target */}
                  <div className="absolute left-0 w-11 h-11 bg-[#E8621A] rounded-full flex items-center justify-center" data-id="element-213">
                    <span className="text-white font-bold text-sm" data-id="element-214">
                      {index + 1}
                    </span>
                  </div>

                  {/* Content */}
                  <div className="flex-1 bg-white border-2 border-[#1A1A1A]/10 rounded-2xl p-6" data-id="element-215">
                    <p className="text-[15px] md:text-[17px] text-[#1A1A1A] font-normal" style={{
                  lineHeight: '1.6'
                }} data-id="element-216">
                      {item}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}